module.exports = __webpack_public_path__ + "static/img/IRENE.97ddad2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/IRENE.png
// module id = Yhja
// module chunks = 0